module.exports = __webpack_public_path__ + "static/media/kinga.afb63e39.jpg";